import { Component, Input } from '@angular/core';
import { CmsFaqContent, CmsFaqValue } from 'parkour-web-app-dto';
import { ParkourAccordionComponent } from '../../shared/components/parkour-accordion/parkour-accordion.component';
import {
  ParkourVideoContentComponent,
  VideoContentType,
} from '../../shared/components/parkour-video-content/parkour-video-content.component';
import { ParkourImageComponent } from '@parkour/ui';

@Component({
  selector: 'parkour-faq-content',
  standalone: true,
  imports: [ParkourAccordionComponent, ParkourImageComponent, ParkourVideoContentComponent],
  templateUrl: './faq-content.component.html',
})
export class FaqContentComponent {
  @Input({ required: true }) content!: CmsFaqContent;

  mapVideo(faqValue: CmsFaqValue): {
    type: VideoContentType;
    id: string;
  } {
    const videoType = faqValue.video?.type?.toLowerCase();
    if (
      faqValue.video &&
      videoType !== undefined &&
      (videoType === 'vimeo' || videoType === 'youtube')
    ) {
      return {
        type: videoType as VideoContentType,
        id: faqValue.video.url ?? '',
      };
    } else {
      return {
        type: 'youtube',
        id: '',
      };
    }
  }
}
